import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useTranslation } from 'react-i18next';

export default function CheckoutCancel() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  return (
    <div className="min-h-screen pt-24 pb-16 bg-[#F9FAFB] flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md px-4"
      >
        <div className="bg-white rounded-3xl shadow-soft p-8 text-center">
          <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-slate-500" />
          </div>
          
          <h1 className="font-heading text-2xl font-bold text-slate-900 mb-2">
            {t('checkout.paymentCancelled')}
          </h1>
          
          <p className="text-slate-600 mb-6">
            {t('checkout.paymentCancelledMessage')}
          </p>
          
          {orderId && (
            <div className="bg-slate-50 rounded-xl p-4 mb-6">
              <p className="text-sm text-slate-500 mb-1">{t('checkout.orderNumber')}</p>
              <p className="font-mono font-medium text-slate-700">{orderId}</p>
              <p className="text-xs text-slate-400 mt-2">
                {t('checkout.orderSavedMessage')}
              </p>
            </div>
          )}
          
          <div className="flex flex-col gap-3">
            <Link to="/products">
              <Button className="w-full btn-primary gap-2" data-testid="retry-payment-btn">
                <ArrowLeft className="w-4 h-4" />
                {t('checkout.retryPayment')}
              </Button>
            </Link>
            
            {orderId && (
              <Link to="/owner">
                <Button variant="outline" className="w-full rounded-full" data-testid="go-dashboard-btn">
                  {t('checkout.goToDashboardToPay')}
                </Button>
              </Link>
            )}
            
            <Link to="/contact">
              <Button variant="ghost" className="w-full rounded-full text-slate-500" data-testid="contact-btn">
                {t('checkout.needHelp')}
              </Button>
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
